module.exports = __webpack_public_path__ + "static/media/pic18.dade8661.jpg";